import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {CompanySearch} from "./CompanySearch";

var vUI_General_Ledger_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_GL_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Meta WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    GENERAL_LEDGER_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Meta Id', columnResourceName: 'colMetaId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    GENERAL_LEDGER_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    ALL_COMPANY_NAME:    {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Company Name', columnResourceName: 'colCompanyName', alignment: HorizAlignment.Left},
        domainOptions: { maxLength: 256}
    },
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "WB Company ID",  columnResourceName: 'colCompWBId',      alignment: HorizAlignment.Center},
        domainOptions: { maxLength: 256,  search: CompanySearch, profileId: "default", searchCondition: {}}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var GeneralLedgerSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_GL_ID',
        id_ui: 'GENERAL_LEDGER_ID',
        name:  'GENERAL_LEDGER_NAME'},


    searchProviderFields: vUI_General_Ledger_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_General_Ledger_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_GL_ID)
                    resolve(returnVals)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var GeneralLedgerSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "GeneralLedgerSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'GENERAL_LEDGER_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'GENERAL_LEDGER_NAME', renderOptions: { }},
        {profileFilterName: 'Company', searchProviderFieldId: 'WB_COMPANY_ID', bMultiSelect: true, renderOptions: {}},
    ],  // ISearchFields
    profileDisplayFields: [
        'GENERAL_LEDGER_ID','GENERAL_LEDGER_NAME', 'ALL_COMPANY_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: GeneralLedgerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var GeneralLedgerSearch: ISearch = {
    searchName: "Find General Ledger",
    renderOptions: { ui5ResourceId: "GeneralLedgerSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [GeneralLedgerSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("GeneralLedgerBO", "GeneralLedger", GeneralLedgerSearch, "GeneralLedger Search")

export {GeneralLedgerSearch}